import { type ActivatedRouteSnapshot, type CanDeactivateFn, type RouterStateSnapshot } from '@angular/router';
import { type Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean;
}

export const canComponentDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate,
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState: RouterStateSnapshot,
) => component.canDeactivate(currentRoute, currentState, nextState);
